import { EStatus } from '../../shared/enums/status.enum';
import { EPriority } from '../points/priorities';

export enum EReminderSeriesFrequency {
  DAILY = 'DAILY',
  WEEKLY = 'WEEKLY',
  MONTHLY = 'MONTHLY',
  YEARLY = 'YEARLY',
}

export type TReminder = {
  reminderId: string;
  name: string;
  description: string;
  targetUserId: string;
  timestampEpochMillis: number; // "default"
  alertEpochMillis: number; // "snoozed time"
  pointId: string;
  pointTitle: string;
  pointStatus: EStatus;
  pointPriority: EPriority;
  workspaceId: string;
  dismissed?: boolean;
  seriesId?: string;
  assignees: string[];
};

export type TReminderDTO = {
  name: string;
  description: string;
  timestampEpochMillis: number;
  pointId: string;
  assignees: string[];
};

export type TReminderUpdateDTO = {
  name?: string;
  description?: string;
  timestampEpochMillis?: number;
  dismissed?: boolean;
  pointId?: string;
  assignees?: string[];
};

export type TReminderActionDTO = {
  reminderIds: string[];
  alertEpochMillis?: number;
};

export type TRemindersSocketMessage = {
  reminders: TReminder[];
};

export type TReminderSeriesNewReminderPayload = {
  name: string;
  description?: string;
  startDateEpochMillis: number;
  pointId?: string;
  endDateEpochMillis?: number;
  frequency: EReminderSeriesFrequency;
  assignees: string[];
};

export type TReminderSeriesUpgradeReminderPayload = {
  reminderId: string;
  endDateEpochMillis?: number;
  frequency: EReminderSeriesFrequency;
  startDateEpochMillis: number;
};

export type TReminderSeriesPayload =
  | TReminderSeriesNewReminderPayload
  | TReminderSeriesUpgradeReminderPayload;

export type TReminderSeriesUpdatePayload = {
  name: string;
  description?: string;
  startDateEpochMillis: number;
  pointId?: string;
  endDateEpochMillis?: number;
  timestampEpochMillis?: number;
  frequency: EReminderSeriesFrequency;
  reminderId: string;
  assignees: string[];
};

export type TReminderSeries = {
  id: string;
  frequency: EReminderSeriesFrequency;
  startDateEpochMillis: number;
  endDateEpochMillis: number;
};
